import { TableArrowLeftIcon } from './TableArrowLeftIcon';

/**
 * author: Michael Irigoyen
 * id 44768ACF-C1A3-477D-91BC-74DA3B0A746E
 * name table-arrow-left
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-arrow-left.svg
 * tags
 */
export const TableImportIcon = TableArrowLeftIcon;
export default TableImportIcon